module.exports = __webpack_public_path__ + "static/cateau1-127f52345ad6143dac241173dee014d5.webp";